
import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import NewPageHero from "@/components/NewPageHero";
import BirthDateCalculator from "@/components/BirthDateCalculator";
import EarlyAccessSection from "@/components/landing/EarlyAccessSection";

// Lazy load non-critical components
const ProcessFlow = lazy(() => import("@/components/ProcessFlow"));
const Partnerships = lazy(() => import("@/components/Partnerships"));
const ContactRepresentative = lazy(() => import("@/components/ContactRepresentative"));
const Footer = lazy(() => import("@/components/Footer"));

// Simple loading component
const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-legatia-orange"></div>
  </div>
);

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <NewPageHero />
      <BirthDateCalculator />
      
      <Suspense fallback={<LoadingSpinner />}>
        <ProcessFlow />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner />}>
        <Partnerships />
      </Suspense>
      
      <EarlyAccessSection />
      
      <Suspense fallback={<LoadingSpinner />}>
        <ContactRepresentative />
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
